import { featuredCategories } from '@/mocks/categories';

export default function FeaturedCategories() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-6 md:px-12">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            Categorie in evidenza
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Esplora le categorie più popolari su Itaobuy Spreadsheet e trova esattamente ciò che cerchi
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-lg overflow-hidden cursor-pointer aspect-square"
            >
              <img
                src={cat.image}
                alt={cat.nameIt}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">
                  {cat.nameIt}
                </h3>
                <p className="mt-2 text-background-50/80 text-sm">
                  {cat.descriptionIt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 bg-background-50/20 backdrop-blur-sm text-background-50 px-4 py-1.5 rounded-full text-xs font-medium">
                  Scopri ora
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}